import { Link } from 'react-router-dom';
import { getLatestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = getLatestUpdates(8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              最近更新
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              每日同步更新，不错过任何精彩内容
            </p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            全部作品
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100/70 transition-all duration-300"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画网最新更新`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col justify-between min-w-0">
                <div>
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-400 mt-1">{comic.author}</p>
                  <div className="flex items-center gap-1 mt-1.5">
                    <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded">
                      {comic.category}
                    </span>
                    <span className="text-xs text-foreground-300">
                      · {comic.status}
                    </span>
                  </div>
                </div>
                <div className="text-xs text-foreground-400 mt-2">
                  更新至第{comic.chapters.length}话 · {comic.updatedAt}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/action"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium"
          >
            查看全部作品
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}